'use client';

import React, { createContext, useState, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { liveKitToken } from '../../redux/action';

const ConnectionContext = createContext(undefined);

export const ConnectionProvider = ({ children }) => {
    const dispatch = useDispatch();
    const { roomId, role } = useParams();

    const [connectionDetails, setConnectionDetails] = useState({
        wsUrl: '',
        token: '',
        shouldConnect: false,
    });

    const connect = useCallback(
        async (mode) => {
            const url = process.env.REACT_APP_LIVEKIT_URL;

            if (!url) throw new Error('Environment variable REACT_APP_LIVEKIT_URL is not set');

            try {
                await new Promise((resolve, reject) => {
                    dispatch(
                        liveKitToken({
                            roomId,
                            mode,
                            role,
                            callback: (data) => {
                                if (data?.accessToken) {
                                    setConnectionDetails({
                                        wsUrl: url,
                                        token: data.accessToken,
                                        shouldConnect: true,
                                    });
                                    resolve();
                                } else {
                                    reject(new Error('Token not received'));
                                }
                            },
                        })
                    );
                });
            } catch (err) {
                console.error('Failed to connect:', err);
            }
        },
        [dispatch, roomId, role]
    );

    const disconnect = useCallback(() => {
        setConnectionDetails((prev) => ({ ...prev, shouldConnect: false }));
    }, []);

    return (
        <ConnectionContext.Provider
            value={{
                wsUrl: connectionDetails.wsUrl,
                token: connectionDetails.token,
                shouldConnect: connectionDetails.shouldConnect,
                connect,
                disconnect,
            }}
        >
            {children}
        </ConnectionContext.Provider>
    );
};

export const useConnection = () => {
    const context = useContext(ConnectionContext);
    if (context === undefined) {
        throw new Error('useConnection must be used within a ConnectionProvider');
    }
    return context;
};
